import React from "react";
import { AiOutlineStop, AiOutlineClose } from "react-icons/ai";

const ErrorMessage = (props) => {
  let { text, customStyle, hide } = props;
  return (
    <div
      className={`${customStyle} border-2 border-[#DF1E1E]  text-[#E0232E] bg-[#FFDEDE] px-4 shadow-md" text-base font-normal py-2 role="alert"`}
    >
      <div className="flex justify-between items-center">
        <div>
          <AiOutlineStop className="w-6 h-6 -mt-1 text-[#E0232E] mr-5 inline-block" />
          <span className="font-bold text-sm text-[#E0232E]">{text}</span>
        </div>

        {hide ? (
          <p className="w-6 h-6 cursor-pointer text-[#E0232E] ml-2"></p>
        ) : (
          <AiOutlineClose
            onClick={() => props.onClick()}
            className="w-6 h-6 cursor-pointer text-[#E0232E] ml-5"
          />
        )}
      </div>
    </div>
  );
};
export default ErrorMessage;
